import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  asModuleTabs?: boolean;
  className?: string;
}

const TabsNavigation = ({ children, className, asModuleTabs = false }: Props) => {
  // helpers
  const getClasses = () => {
    let moduleClass = asModuleTabs ? " mb-4 mt-md-n2" : "";
    let propsClass = className ? ` ${className}` : "";
    return `d-flex${moduleClass}${propsClass}`;
  }

  // render
  return (
    <div className={getClasses()}>
      {children}
    </div>
  )
}

export default TabsNavigation;
